export default function showBgElements(){
    if($(window).width() > 1599 && $('.js-bg-container').outerHeight() > 1999){
        $('.js-bg-element').show();
    }
}
